import {
    Component,
    EventEmitter,
    Output,

    ViewChild,
    OnInit,

} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { ETheme } from '../enums/ETheme.enum';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertaVagasComponent } from '../utilidades/alerta-vagas/alerta-vagas.component';
import { AlarmeService } from '../service/alarme.service';
import { indicadorDTO } from '../modal/dto/indicadorDTO';
import { valor } from '../modal/valor';
import { UtilSharedDataService } from '../service/UtilSharedDataService';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AlertaService } from '../utilidades/alerta.service';
import { authConfigIdp } from '../auth/idp.sp/auth-config-idp';
import { ParametroHeaderService } from '../service/parametroHeader.service';
@Component({
    selector: 'app-header',
    standalone: true,
    imports: [
        CommonModule,
        // * MATERIAL IMPORTS
        MatSidenavModule,
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatDividerModule,
        MatListModule,
        AlertaVagasComponent
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
    @Output() themeToggle = new EventEmitter<string>();
    salaSituacao: any;
    data = [];
    tempoAtualizacao: any;
    tempoAtualizacaoExclamacao: any;
    dataRet = [];
    dataRetExclamacao = [];
    ModoApresentacao: boolean = false;
    dataCampos = [];
    dataCamposExclamacao = [];

    urlFoto = "";
    width = 0;
    alt = "";
    nomeLogo = "";
    height = 0;
    periodoEleitoral: boolean | null = null;
    numTentativas = 0;

    public listaInd: indicadorDTO[] = [];
    public listaIndExclamacao: indicadorDTO[] = [];
    public openalerta: boolean = false;
    onToggleTheme(theme: string) {
        this.themeToggle.emit(theme);
    }
    // Se o icon for sun o tema recebe light
    // Se o icon for moon o tema recebe dark, e
    public icon: any;
    public iconSun = ETheme.ICON_SUN;
    public iconMoon = ETheme.ICON_MOON;
    login: string | null | undefined
    inativo: boolean | null | undefined
    numeroAlertas: number = 0;
    numeroAlertasExclamacao: number = 0;
    VisualizacaoPadrao: string = "LIGHT";
    public themeClass: string = this.VisualizacaoPadrao == "DARK" ? 'main maindark' : 'main';
    @ViewChild(AlertaVagasComponent) alertComponent!: AlertaVagasComponent;
    @ViewChild(AlertaVagasComponent) alertExclamationComponent!: AlertaVagasComponent;
    isMobile = false;
    usuarioInativo = false;
    CiberarkStatus = true;

    constructor(public dialog: MatDialog,private ParametroHeaderService: ParametroHeaderService, public router: Router, private utilSharedDataService: UtilSharedDataService, public alertaService: AlertaService,
        private oauthService: OAuthService,
        private authService: AuthService, private alarmeService: AlarmeService, private alarmeServiceExclamacao: AlarmeService, private bpObserver: BreakpointObserver) {
        const localStorage = document.defaultView?.localStorage;
        this.bpObserver.observe(['(max-width: 740px)'])
            .subscribe(ret => {
                this.isMobile = ret.matches; // true se está em tela de celular
                console.log("É CONSOLE: ", this.isMobile);
            });
        if (localStorage) {

            try {
                this.login = localStorage.getItem('login');
            }
            catch (ex) {
                this.login = undefined;
            }
            try {
                this.inativo = localStorage.getItem('inativo') === 'true';
            }
            catch (ex) {
                this.inativo = undefined;
            }
            var NewVisu = localStorage.getItem('MODOTELA');
            this.VisualizacaoPadrao = NewVisu == null ? "LIGHT" : NewVisu;
        }
    }
    setModoApresentacao(statusModoApresentacao: boolean) {
        this.utilSharedDataService.updateModoApresentacao(statusModoApresentacao);
        this.ModoApresentacao = statusModoApresentacao;
    }
    ngOnInit() {
        this.utilSharedDataService.modoApresentacao$.subscribe(boolean => {
            this.ModoApresentacao = boolean;
        });
        (async () => {
            this.login = undefined;
            try {
                await new Promise(f => setTimeout(f, 500));
                let flogin = localStorage.getItem('forca-login');
                if (flogin != "true") {
                    this.findConfigCiberArk();
                    const provider = localStorage.getItem('auth_provider');
                    console.log("provider", provider);
                    if (provider != 'CYBERARK') {
                        let token = this.oauthService.getAccessToken();
                        console.log("CHECK TOKEN", token, this.oauthService.hasValidAccessToken());
                        if (this.oauthService.hasValidAccessToken()) {

                            let claims = this.oauthService.getIdentityClaims();
                            if (claims) {
                                localStorage.setItem('deslogar', "false");
                                localStorage.setItem('token', token);

                                this.authService.getRoles(claims['preferred_username']).pipe(
                                ).subscribe((response) => {
                                    //console.table(response);
                                    this.inativo = response['meusDados']['roles']['salaSituacao']['inativo'];
                                    localStorage.setItem('inativo', this.inativo + "");
                                    if (!this.inativo) {
                                        localStorage.setItem('login', response.nome);
                                        this.salaSituacao = response['meusDados']['roles']['salaSituacao'];
                                        //console.log(this.salaSituacao['perfil']);
                                        localStorage.setItem('salaSituacao', JSON.stringify(this.salaSituacao));
                                    }
                                    let login = response.nome;
                                    console.log(response.nome);
                                    if (this.salaSituacao != null && !this.inativo) {
                                        var postosUsuario = this.salaSituacao['postos'];
                                        this.getAlerta(postosUsuario, login, 3);
                                        this.getAlerta(postosUsuario, login, 5);
                                    }
                                    if (this.inativo) {
                                        // Mostrar mensagem de usuário inativo
                                        this.mostrarMensagemInativo();
                                    }
                                });

                                this.login = localStorage.getItem('login');
                            } else {
                                this.removerLogin("false");
                            }
                        }
                    } else {
                        // Tenta usar token interno JWT vindo do back
                        const jwt = localStorage.getItem('token');

                        if (jwt) {

                            // ⚠ Aqui pega o CPF direto do localStorage
                            const cpf = localStorage.getItem('cpf');  // já está sendo salvo no CyberArk
                            //const sala = localStorage.getItem('salaSituacao');
                            //console.log("cpf", cpf);

                            // Buscar dados no backend (mesma chamada usada no IDP)
                            this.authService.getRoles(cpf!)
                                .subscribe(response => {

                                    this.inativo = response['meusDados']['roles']['salaSituacao']['inativo'];
                                    localStorage.setItem('inativo', this.inativo + "");

                                    if (!this.inativo) {
                                        localStorage.setItem('login', response.nome);
                                        this.salaSituacao = response['meusDados']['roles']['salaSituacao'];
                                        //console.log(this.salaSituacao['perfil']);
                                        localStorage.setItem('salaSituacao', JSON.stringify(this.salaSituacao));
                                    }
                                    let login = response.nome;
                                    console.log(response.nome);
                                    if (this.salaSituacao != null && !this.inativo) {
                                        var postosUsuario = this.salaSituacao['postos'];
                                        this.getAlerta(postosUsuario, login, 3);
                                        this.getAlerta(postosUsuario, login, 5);
                                    }
                                    if (this.inativo) {
                                        // Mostrar mensagem de usuário inativo
                                        this.mostrarMensagemInativo();
                                    }
                                    this.login = localStorage.getItem('login');
                                });
                            return;
                        }

                        // Nenhum login disponível → fluxo normal
                        this.removerLogin("false");
                    }
                    this.buscaheader();
                }
                else {
                    this.login = localStorage.getItem('login');
                    var retrievedObject = localStorage.getItem('salaSituacao');
                    if (retrievedObject != null && !this.inativo) {
                        var sala = JSON.parse(retrievedObject);
                        var postosUsuario = sala['postos'];
                        var login = localStorage.getItem('login')
                        this.getAlerta(postosUsuario, login == null ? undefined : login, 3);
                        this.getAlerta(postosUsuario, login == null ? undefined : login, 5);
                    }
                    this.buscaheader();
                }
            }
            catch (ex) {
                this.removerLogin("false");
            }
            
        })();
        //localStorage.setItem('token', "token");
        //localStorage.setItem('login', "ENTRA A FORÇA");
    }

    buscaheader()
  {
    this.ParametroHeaderService
      .buscarParametrosHeaderAtivobyTipo("Junto_Sala_Situacao")
      .subscribe(
        (result) => {
          this.numTentativas = 0;
          var element = result["Parametro_Header"]
          this.urlFoto = element.foto;
          this.width = element.width;
          this.height = element.height;
          this.alt = element.alt;
          this.nomeLogo = element.nome;
          this.periodoEleitoral = element.periodoEleitoral;
        },
        (error) => {
          if(this.numTentativas<4){
            this.buscaheader();
            this.numTentativas++;
          }
          console.log(Error);
        }
      );
  }

    findConfigCiberArk(): void {
        this.authService.findConfigCiberArk().subscribe(
            (response) => {
                console.log(response["SalaConfig"]["status"]);
                this.CiberarkStatus = response["SalaConfig"]["status"];
            },
            (error) => {
                console.error('Erro ao excluir o item:', error);
            }
        );

    }

    mostrarMensagemInativo() {
        this.usuarioInativo = true;
        //setTimeout(() => this.usuarioInativo = false, 10000); // Some após 10 segundos
    }

    getAlerta(postosUsuario: any, login: undefined | string, tipoGraficoIndicador: number) {
        if (tipoGraficoIndicador == 3) {
            this.alarmeService.getAlertas(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador).pipe(
            ).subscribe((responsealarme) => {
                this.numeroAlertas = responsealarme["indicadores"].length;
                this.tempoAtualizacao = responsealarme["tempoAtualizacao"];
                this.listaInd = [];
                this.dataCampos = responsealarme["camposGrafico"];
                this.dataRet = responsealarme["indicadores"];
                let i = 0;
                this.dataRet.forEach(element => {
                    var v = element['valor'];
                    var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null
                        , new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], [], "");
                    var val = new valor(
                        v['codigo'],
                        v['nome'],
                        v['expressao'],
                        v['icone'],
                        v['denominador'],
                        v['nominador'],
                        v['valorFormatado'],
                        v['valorSemFormato'],
                        v['naoMostraCampo'],
                        v['naoMostraTitulo'],
                        v['orientacaoLoop'],
                        v['ehLooping'],
                        v['ehComponenteGrafico'],
                        v['componenteGraficoHtml'],
                        v['componenteGraficoCss'],
                        v['componenteGraficoPossicao'],
                        v['ehLink'],
                        v['linkRedirect'],
                        v['linkVariaveis'],
                        v['ordem'],
                        v['ehCampoCabecalho'],
                        this.getValores(v['valores'], ind),
                        v['cor']
                    )
                    ind.valor = val;
                    ind.valores = this.getValores(element['valores'], ind)
                    this.listaInd.push(ind);
                });

                this.setAtualizacaoalerta(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador);
            });
        } else {
            this.alarmeServiceExclamacao.getAlertas(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador).pipe(
            ).subscribe((responsealarme) => {
                this.numeroAlertasExclamacao = responsealarme["indicadores"][0].valor.valorFormatado;
                this.tempoAtualizacaoExclamacao = responsealarme["tempoAtualizacao"];
                this.listaIndExclamacao = [];
                this.dataCamposExclamacao = responsealarme["camposGrafico"];
                this.dataRetExclamacao = responsealarme["indicadores"];
                let i = 0;
                this.dataRetExclamacao.forEach(element => {
                    var v = element['valor'];
                    var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null
                        , new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], [], "");
                    var val = new valor(
                        v['codigo'],
                        v['nome'],
                        v['expressao'],
                        v['icone'],
                        v['denominador'],
                        v['nominador'],
                        v['valorFormatado'],
                        v['valorSemFormato'],
                        v['naoMostraCampo'],
                        v['naoMostraTitulo'],
                        v['orientacaoLoop'],
                        v['ehLooping'],
                        v['ehComponenteGrafico'],
                        v['componenteGraficoHtml'],
                        v['componenteGraficoCss'],
                        v['componenteGraficoPossicao'],
                        v['ehLink'],
                        v['linkRedirect'],
                        v['linkVariaveis'],
                        v['ordem'],
                        v['ehCampoCabecalho'],
                        this.getValores(v['valores'], ind),
                        v['cor']
                    )
                    ind.valor = val;
                    ind.valores = this.getValores(element['valores'], ind)
                    this.listaIndExclamacao.push(ind);
                });

                this.setAtualizacaoalerta(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador);
            });
        }
    }

    AbrirAlertas() {
        this.alertaService.abrir();
        this.alertComponent.abrirAlerta();
    }

    AbrirAlertasExclamacao() {
        this.router.navigate(['/indicador-alerta']);
    }

    irParaMinhaArea() {
        this.router.navigate(['/ciberark']);
    }

    loginGovBr() {
        localStorage.setItem('auth_provider', 'govbr');
        localStorage.setItem('forca-login', "false");
        this.oauthService.configure(authConfigIdp);
        this.oauthService.loadDiscoveryDocumentAndLogin();
        let login = localStorage.getItem('login');
        if (login != null && login != undefined)
            this.router.navigate(['/dashboard']);
    }

    retornoParaHome() {
        this.router.navigate(['dashboard']);
    }

    AlterarModoTela(newvisu: string) {
        const localStorage = document.defaultView?.localStorage;
        if (localStorage) {
            //localStorage.setItem('VISUPADRAO', newvisu);
            localStorage.setItem('MODOTELA', newvisu);
            this.VisualizacaoPadrao = newvisu;
        }
        this.themeClass = this.VisualizacaoPadrao == "DARK" ? 'main maindark' : 'main';
        this.onToggleTheme(newvisu);
    }

    deslogar() {

        let flogin = localStorage.getItem('forca-login');
        if (flogin == "true") {
            console.log('deslogar: localStorage.clear()');
            localStorage.clear();
            localStorage.setItem('forca-login', "false");
            this.router.navigate(['/iniciar']);
        }

        // Descobre qual provider foi usado
        const provider = localStorage.getItem('auth_provider');
        console.log("provider", provider);
        if (provider === 'CYBERARK') {

            // usa o AuthService
            //this.authService.logoutCyberArk().subscribe({
            //    next: (redirectUrl: string) => {
            //       localStorage.clear();
            //        console.log("redirectUrl CIBERARK", redirectUrl);
            //alert(redirectUrl);
            //        if (redirectUrl) {
            //           window.location.href = redirectUrl;
            //        } else {
            //            this.router.navigate(['/iniciar']);
            //        }
            //        this.removerLogin("true");
            //    },
            //    error: err => {
            //        console.error("Erro CyberArk logout", err);
            //        localStorage.clear();
            //        this.router.navigate(['/iniciar']);
            //        this.removerLogin("true");
            //    }
            //});
            localStorage.clear();
            this.router.navigate(['/iniciar']);

            return;
        }

        this.alertComponent.closeChat();
        this.alertExclamationComponent.closeChat();
        localStorage.removeItem('auth_provider');
        this.oauthService.logOut();
        this.removerLogin("true");
        this.router.navigate(['/iniciar']);
    }

    removerLogin(EhuserDeslogar: string) {
        console.log("removerLogin")
        const localStorage = document.defaultView?.localStorage;
        if (localStorage) {
            //localStorage.removeItem('login');
            //localStorage.removeItem('token');
            console.log('removerLogin: localStorage.clear()');
            localStorage.clear();
            this.login = undefined;
            this.salaSituacao = undefined;
            localStorage.setItem('deslogar', EhuserDeslogar);
            //this.router.navigate(['/iniciar']);
        }
    }

    public role() {
        var local: any = localStorage.getItem('salaSituacao');
        local = JSON.parse(local);
        var roles = local.perfil;
        return roles
    }

    setAtualizacaoalerta(postosUsuario: number[] | undefined, login: string, tipoGraficoIndicador: number) {
        if (tipoGraficoIndicador == 3) {
            const intervalId = setInterval(() => {
                this.alarmeService.getAlertas(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador).pipe(
                ).subscribe((responsealarme) => {
                    //console.log("TEMPO", responsealarme);
                    this.numeroAlertas = responsealarme["indicadores"].length;
                    this.tempoAtualizacao = responsealarme["tempoAtualizacao"];
                    this.listaInd = [];
                    this.dataCampos = responsealarme["camposGrafico"];
                    this.dataRet = responsealarme["indicadores"];
                    let i = 0;
                    this.dataRet.forEach(element => {
                        var v = element['valor'];
                        var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null
                            , new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], [], "");
                        var val = new valor(
                            v['codigo'],
                            v['nome'],
                            v['expressao'],
                            v['icone'],
                            v['denominador'],
                            v['nominador'],
                            v['valorFormatado'],
                            v['valorSemFormato'],
                            v['naoMostraCampo'],
                            v['naoMostraTitulo'],
                            v['orientacaoLoop'],
                            v['ehLooping'],
                            v['ehComponenteGrafico'],
                            v['componenteGraficoHtml'],
                            v['componenteGraficoCss'],
                            v['componenteGraficoPossicao'],
                            v['ehLink'],
                            v['linkRedirect'],
                            v['linkVariaveis'],
                            v['ordem'],
                            v['ehCampoCabecalho'],
                            this.getValores(v['valores'], ind),
                            v['cor']
                        )
                        ind.valor = val;
                        ind.valores = this.getValores(element['valores'], ind)
                        this.listaInd.push(ind);
                    });
                    this.alertComponent.setdados(this.listaInd);
                });
            }, (this.tempoAtualizacao * 100));
        } else {
            const intervalId = setInterval(() => {
                this.alarmeServiceExclamacao.getAlertas(postosUsuario, login == undefined ? "" : login, tipoGraficoIndicador).pipe(
                ).subscribe((responsealarme) => {
                    this.numeroAlertasExclamacao = responsealarme["indicadores"][0].valor.valorFormatado;
                    this.tempoAtualizacaoExclamacao = responsealarme["tempoAtualizacao"];
                    this.listaIndExclamacao = [];
                    this.dataCamposExclamacao = responsealarme["camposGrafico"];
                    this.dataRetExclamacao = responsealarme["indicadores"];
                    let i = 0;
                    this.dataRetExclamacao.forEach(element => {
                        var v = element['valor'];
                        var ind: indicadorDTO = new indicadorDTO(undefined, "", "", 0, "", "", "", null
                            , new valor(undefined, "", "", "", 0, 0, "", 0, null, null, null, null, null, null, null, null, null, null, null, 0, null, [], null), [], [], "");
                        var val = new valor(
                            v['codigo'],
                            v['nome'],
                            v['expressao'],
                            v['icone'],
                            v['denominador'],
                            v['nominador'],
                            v['valorFormatado'],
                            v['valorSemFormato'],
                            v['naoMostraCampo'],
                            v['naoMostraTitulo'],
                            v['orientacaoLoop'],
                            v['ehLooping'],
                            v['ehComponenteGrafico'],
                            v['componenteGraficoHtml'],
                            v['componenteGraficoCss'],
                            v['componenteGraficoPossicao'],
                            v['ehLink'],
                            v['linkRedirect'],
                            v['linkVariaveis'],
                            v['ordem'],
                            v['ehCampoCabecalho'],
                            this.getValores(v['valores'], ind),
                            v['cor']
                        )
                        ind.valor = val;
                        ind.valores = this.getValores(element['valores'], ind)
                        this.listaIndExclamacao.push(ind);
                    });
                    this.alertExclamationComponent.setdados(this.listaInd);
                });
            }, (this.tempoAtualizacaoExclamacao * 100));
        }
    }

    getValores(response: [], ind: indicadorDTO): valor[] {
        if (response == undefined) {
            return [];
        }
        var listavalores: valor[] = [];
        response.forEach(element => {
            var val = new valor(
                element['codigo'],
                element['nome'],
                element['expressao'],
                element['icone'],
                element['denominador'],
                element['nominador'],
                element['valorFormatado'],
                element['valorSemFormato'],
                element['naoMostraCampo'],
                element['naoMostraTitulo'],
                element['orientacaoLoop'],
                element['ehLooping'],
                element['ehComponenteGrafico'],
                element['componenteGraficoHtml'],
                element['componenteGraficoCss'],
                element['componenteGraficoPossicao'],
                element['ehLink'],
                element['linkRedirect'],
                element['linkVariaveis'],
                element['ordem'],
                element['ehCampoCabecalho'],
                this.getValores(element['valores'], ind),
                element['cor']
            )
            listavalores.push(val);
        });
        return listavalores;
    }
}



/*

 onClickToggleDarkTheme() {
        const evento = this.toggleDarkTheme.emit();
        // if( this.isDarkTheme ){
        //     this.icon = ETheme.ICON_MOON;
        //     this.toggleDarkTheme.emit();
        // }
        //return evento
    }

    // public toggleDarkTheme() {
    // const body = this.renderer.selectRootElement('body');
    // const isDarkTheme = body.classList.contains('moon-dark-theme');
    // // Alterna entre os temas
    // body.classList.toggle('moon-dark-theme');
    // body.classList.toggle('sun-light-theme');
    // // Atualiza o ícone conforme o tema selecionado
    // if (isDarkTheme) {
    //     this.icon = ETheme.ICON_MOON; // Se estava no tema dark, troca para o ícone de lua
    // } else {
    //     this.icon = ETheme.ICON_SUN; // Se estava no tema light, troca para o ícone de sol
    // }
    // // Define o background-color conforme o tema selecionado
    // const themeColor = isDarkTheme ? 'var(--body-light)' : 'var(--body-dark)';
    // this.renderer.setStyle(body, 'background-color', themeColor);
    // }



AQUI FUNCIONA
public toggleDarkTheme(){
        let theme = document.body.classList.toggle('moon-dark-theme');
        if( theme ){
            return this.icon = ETheme.ICON_SUN;
        }
        return this.icon = ETheme.ICON_MOON;
    }

 public buttonThemeDARK(){
    this.buttonDark.nativeElement.classList.toggle('sun-light-theme')
    if( this.buttonDark ){
        this.buttonDark.nativeElement.classList.toggle('moon-dark-theme')
        return this.icon = ETheme.ICON_SUN
    }
    return (this.icon = ETheme.ICON_MOON)
  }
*/
